import { render, staticRenderFns } from "./MSecondaryHelp.vue?vue&type=template&id=41b84fdf&"
import script from "./MSecondaryHelp.vue?vue&type=script&lang=ts&"
export * from "./MSecondaryHelp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports